export const COMPETITION_STATUSES = {
  LAUNCHED: 'LAUNCHED',
  IN_PROGRESS: 'IN_PROGRESS',
  REWARD_DISTRIBUTION: 'REWARD_DISTRIBUTION',
  FINISHED: 'FINISHED',
}
